module.exports = __webpack_public_path__ + "img/Brett.5981e2a3.jpeg";